export const buttonLabel = 'Show more information'
